import React from 'react';
import PropTypes from 'prop-types';

// Campo de busca no desenho do bloco de busca do DS (.ag-searchblock). Sem
// JavaScript, o formulário envia para /search do mesmo jeito.
const CampoBusca = ({ valor, onBuscar, placeholder }) => {
  const [texto, setTexto] = React.useState(valor);
  React.useEffect(() => setTexto(valor), [valor]);

  const enviar = (e) => {
    const termo = texto.trim();
    e.preventDefault();
    if (termo) onBuscar(termo);
  };

  return (
    <form
      className="ag-searchblock ag-busca__campo"
      role="search"
      action="/search"
      method="get"
      onSubmit={enviar}
    >
      <input
        type="search"
        className="ag-searchblock__input"
        name="SearchableText"
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        placeholder={placeholder}
        aria-label="Buscar no site"
      />
      <button type="submit" className="ag-searchblock__btn" aria-label="Buscar">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </button>
    </form>
  );
};

CampoBusca.propTypes = {
  valor: PropTypes.string,
  onBuscar: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

CampoBusca.defaultProps = {
  valor: '',
  placeholder: 'O que você procura?',
};

export default CampoBusca;
